module.exports = __webpack_public_path__ + "website/static/img/partner2.675260e.png";


//////////////////
// WEBPACK FOOTER
// ./src/module/landPage/index/img/partner2.png
// module id = cyaR
// module chunks = 6